import React from 'react'
import styled from '@emotion/styled'
import { ApiShopperLandingPageLink } from '@storefronts/common-types'
import { inScrollingDesktop } from '../../style/scrollingLayout'
import { ProductSortDropdown } from './ProductSortDropdown'
import { ProductLayoutToggle } from './ProductLayoutToggle'
import { FilterState, ProductFilterDialog } from './ProductFilterDialog'

const ControlsContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    padding: '6px 10px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '0.2rem',
    // On a wide track the controls read as part of the grid below them rather
    // than as a widget. At phone width the grid is the whole column, so the
    // box is what separates them.
    ...inScrollingDesktop({ border: 'none', paddingInline: 0 }),
})

interface ProductControlsProps {
    products?: ApiShopperLandingPageLink[]
    filterState: FilterState
    hideLayoutToggle?: boolean
}

export const ProductControls: React.FC<ProductControlsProps> = ({
    products,
    filterState,
    hideLayoutToggle = false,
}) => {
    const productCount = products?.length || 0

    return (
        <>
            <ControlsContainer>
                {!hideLayoutToggle && (
                    <ProductLayoutToggle productCount={productCount} />
                )}
                <ProductFilterDialog
                    filterState={filterState}
                    products={products}
                />
                <ProductSortDropdown products={products} />
            </ControlsContainer>
        </>
    )
}
